export default __webpack_public_path__ + "97a6cbe445668176647f3fd069a2d267.jpg";